import { ITagStatus } from '@tecalisdev/infinity';
import { BOOLEAN_STATUS } from '../../processes/models/processes.models';
import { MenuItemAction } from '../../shared/models/master.models';
import { IOperationActivity, IOperationBormeDetail, OPERATION_STATUS } from '../models/operations.models';

export interface BormeActivityLogContext {
	startAt?: string | null;
	endAt?: string | null;
	logsUrl?: string | null;
}

export interface BormeActivityLogDeps {
	translate: (key: string, params?: Record<string, unknown>) => string;
	getTagStatus: (state: string) => ITagStatus;
}

/** Actividad BORME (solo ops). */
export function appendBormeActivityLogs(
	activity: IOperationActivity[],
	borme: IOperationBormeDetail,
	context: BormeActivityLogContext,
	deps: BormeActivityLogDeps,
): void {
	const startAt = context.startAt ?? borme.start_at;
	if (startAt) {
		activity.push({
			date: startAt,
			description: [deps.translate('PROCESSES.DETAIL.INIT_OPERATION')],
			...(context.logsUrl ? { showLogs: true } : {}),
		});
	}

	activity.push({
		title: deps.translate('OPERATIONS.DETAIL.BORME.ACTIVITY_STEP_TITLE'),
		icon: borme.mode === 'manual' ? 'icon-file' : 'icon-connection',
		status: (borme.state as unknown as BOOLEAN_STATUS) ?? BOOLEAN_STATUS.OK,
		description: borme.result_summary ? [borme.result_summary] : [],
	});

	const endAt = context.endAt ?? borme.end_at;
	if (endAt) {
		activity.push({
			description: [deps.translate('PROCESSES.DETAIL.FINISH_SCAN')],
			tag: borme.state
				? {
						label: deps.translate(`MASTER.STATUS.${String(borme.state).toUpperCase()}`),
						status: deps.getTagStatus(String(borme.state)),
					}
				: undefined,
			date: endAt,
			link: {
				label: deps.translate('GENERAL.SHOW_RESPONSE'),
				action: MenuItemAction.SHOW_JSON,
				info: {
					title: deps.translate('OPERATIONS.DETAIL.BORME.ACTIVITY_JSON_TITLE'),
					data: borme,
				},
			},
		});
	}
}

export function normalizeBormeActivityState(
	state: string | OPERATION_STATUS | undefined,
): OPERATION_STATUS | undefined {
	if (state === undefined || state === null) return undefined;
	const upper = String(state).toUpperCase();
	const values = Object.values(OPERATION_STATUS) as string[];
	return values.includes(upper) ? (upper as OPERATION_STATUS) : undefined;
}
